module.exports = __webpack_public_path__ + "static/media/AW_HP_EN_766x844_Lemonade.a87521c6.jpg";